export const ULTIMOS_COMUNICADOS = 2;
export const CAMPO_OBRIGATORIO = 'Campo obrigatório';
export const EMAIL_INVALIDO = 'E-mail inválido';


// WEBPACK FOOTER //
// ./src/app/components/base/util/constants.ts